import React, { Component } from 'react';

export default class view extends Component {
	constructor(props) {
		super(props)
		this.state = {
			CalsReqError: null
		}
	}
	checkCalsReq = (e) => {
		//console.log("here")
		let valid = false;
		//console.log(this.state.data.CalsReq);
		//console.log(this)
		//let CaloricUnits = ((parseInt(this.props.data.CalsReq) / 100) * 30)
		if (this.props.data.InbornMetabolic || this.props.data.ModeOfAdmin == "T") {
			console.log("inbornMetatbolic")
			//Max is 2000
			if (!parseInt(this.props.data.CalsReq) || parseInt(this.props.data.CalsReq) <= 0) {
				//invalid
				console.log("Check 1")
				this.setState({ CalsReqError: 'That is not a valid response' })
			} else {
				//valid keep going
				//this.props.setData('CaloricUnits', ((parseInt(this.props.data.CalsReq) / 100) * 30))
				valid = true;
			}
		} else {
			//Max is 1000
			if (!parseInt(this.props.data.CalsReq) || parseInt(this.props.data.CalsReq) <= 0) {
				//invalid
				//Do age check
				console.log("Age check?")
				valid = true;
				//this.props.navigate(new Date().getTime() - new Date(this.props.data.DOB).getTime() < 31536000000 ? 'R13' : 'R14')
			} else {
				//valid
				//this.props.setData('CaloricUnits', ((parseInt(this.props.data.CalsReq) / 100) * 30))
				valid = true;
			}
		}
		if (valid) {
			console.log("Valid Response")
			this.props.setData('CaloricUnits', ((parseInt(this.props.data.CalsReq) / 100) * 30))
			fetch(window.location.origin + window.location.pathname + 'R11Check', { method: 'POST', headers: { "Content-Type": 'application/json' }, body: JSON.stringify({ data: this.props.data }) }).then(async (response) => {
				if (response.status == 200) {
					var result = await response.text();
					console.log(result);
					this.props.navigate(result)
				} else {
					console.log(response.status)
					if (response.status == 406) {
						var result = await response.text();
						this.setState({ CalsReqError: result })
					} else {
						this.setState({ CalsReqError: "Unexpected Error has Occured" })
					}
				}
			})
		} else {
			console.log("Invalid Result")
		}

	}

	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>Enter the total number of calories being prescribed per day for this Enteral formula.</p>
				<input type="number" value={this.props.data.CalsReq} onChange={(e) => { this.props.setData('CalsReq', e.currentTarget.value) }} />
				{this.state.CalsReqError ? <div className="error">{this.state.CalsReqError}</div> : ''}
				<div className="button" onClick={() => { this.checkCalsReq() }}>Continue</div>
			</div>
		);
	}
}